import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { environment } from '@environments/environment';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { routes } from './app.routes';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HiringManagerOpenpositionsModule } from './pages/hiring-manager/hiring-manager.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { VendorModule } from './pages/vendor/vendor.module';
import { OpsModule } from './pages/ops-team/ops.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './core/loader.interceptor';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderService } from './shared/services/loader.service';
import { VendorManagementModule } from './pages/vendor-management/vendor-management.module';
import { AuthInterceptor } from './core/auth.interceptor';
import { VendorRepModule } from './pages/vendor-rep/vendor-rep.module';
import { OpsVendorManagementModule } from './pages/ops-vendor-management/ops-vendor-management.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { TeamManagementModule } from './pages/team-management/team-management.module';
import { SideNavbarComponent } from "./layout/side-navbar/side-navbar.component";
import { EmeraldSideNavigationModule } from '@emerald-angular/side-navigation';
import { AssetManagementModule } from './pages/asset-management/asset-management.module';
import { ContractorFlowModule } from './pages/contractor-flow/contractor-flow.module';
import { FinanceModule } from './pages/finance/finance.module';
import { AdoptionModule } from './pages/adoption/adoption.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes),
    HiringManagerOpenpositionsModule,
    VendorManagementModule,
    OktaAuthModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    EmeraldDesignSystemModule,
    VendorModule,
    OpsModule,
    OverlayPanelModule,
    NgxSkeletonLoaderModule,
    VendorRepModule,
    OpsVendorManagementModule,
    TeamManagementModule,
    MatDatepickerModule,
    MatNativeDateModule,
    EmeraldTabBarModule,
    EmeraldSideNavigationModule,
    AssetManagementModule,
    ContractorFlowModule,
    FinanceModule,
    AdoptionModule,
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SideNavbarComponent,
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: OKTA_CONFIG, useValue: environment.okta }, // Use the okta configuration from the environment
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
